export default __webpack_public_path__ + "static/media/Chrome.9edcb5c4.svg";